import { SIGNAL_NAMES } from '../signals/constants';
import { FEATURE_NAMES } from '../features/constants';

export const loaderPriority = {
  // Signals First
  [SIGNAL_NAMES.context]: 1,
  [SIGNAL_NAMES.traces]: 2,
  [SIGNAL_NAMES.logs]: 3,
  [SIGNAL_NAMES.metrics]: 4,
  [SIGNAL_NAMES.events]: 5,
  [SIGNAL_NAMES.spans]: 6,
  // Features Second
  [FEATURE_NAMES.failedLoadResources]: 10,
  [FEATURE_NAMES.sessionTrace]: 11,
  [FEATURE_NAMES.resourceTiming]: 12,
  [FEATURE_NAMES.webVitals]: 13,
  [FEATURE_NAMES.sessionReplay]: 14,
  [FEATURE_NAMES.heaviestResources]: 15,
};
